import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { combineLatest, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { UserClaims } from 'src/app/model/okta/userClaims';
import { AccountService } from 'src/app/core/services/account.service';
import { ADPResourceService } from 'digital-core';
import { SnackbarService } from 'src/app/core/services/snackbar/snackbar.service';

@Component({
  selector: 'pgh-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit, OnDestroy {

  user: UserClaims;
  contract: ISelectedContract;
  initialLoad: boolean = false;
  manageUrl: string;

  private $destroy = new Subject<boolean>();

  constructor(
    private loggedInUserSettings: LoggedInUserSettings,
    private resourceService: ADPResourceService
  ) { }

  ngOnInit() {
    combineLatest([
      this.loggedInUserSettings.$selectedContract,
      this.loggedInUserSettings.$userClaims
    ]).pipe(
      filter(([a, b]) => a !== null && b !== null),
      takeUntil(this.$destroy))
      .subscribe(([contract, user]) => {
        this.user = user;
        this.contract = contract;
      });

    this.initialLoad = true;
    this.manageUrl = this.getResource('URL_Account_Subscription_Mangement').Value;
  }

  ngOnDestroy() {
    this.$destroy.next(true);
  }

  getResource(title: string) {
    let resourceValue = this.resourceService.getPortalSetting(title);
    return resourceValue;
  }
}
